export default __webpack_public_path__ + "static/cta-video-thumbnail-1b53db1c8527fdb969eec3f2844dd895.webp";